/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	LoomAuthStateQuery$data as LoomAuthStateQuery,
	LoomAuthStateQuery$variables as LoomAuthStateQueryVariables,
} from '../__generated__/LoomAuthStateQuery.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum LoomUserStatus {
  LINKED = "LINKED",
  LINKED_ENTERPRISE = "LINKED_ENTERPRISE",
  MASTERED = "MASTERED",
  NOT_FOUND = "NOT_FOUND",
}

